import React from 'react';
import { Text, makeStyles } from '@fluentui/react-components';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

const MOBILE = '@media (max-width: 768px)';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 'var(--space-md)',
    marginBottom: 'var(--space-lg)',
    [MOBILE]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  titleGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--space-xs)',
  },
  title: {
    fontSize: '24px',
    fontWeight: '600',
    color: 'var(--color-text)',
    letterSpacing: '-0.3px',
    lineHeight: '1.2',
  },
  subtitle: {
    fontSize: '14px',
    color: 'var(--color-text-secondary)',
  },
  actions: {
    display: 'flex',
    gap: 'var(--space-sm)',
    alignItems: 'center',
    flexShrink: 0,
    flexWrap: 'wrap',
  },
});

export default function PageHeader({ title, subtitle, actions }: PageHeaderProps) {
  const s = useStyles();

  return (
    <div className={s.root}>
      <div className={s.titleGroup}>
        <Text as="h1" className={s.title}>{title}</Text>
        {subtitle && <Text className={s.subtitle}>{subtitle}</Text>}
      </div>
      {actions && <div className={s.actions}>{actions}</div>}
    </div>
  );
}
